import CrmApi from '../../../api/CrmApi';
import EvidenceKind from '../../constants-v2/bookkeeping/evidence-kind';
import BANKING from '../../constants-v2/person/open-banking';
import crmName from '../../filters/crm-name';
import HttpBuildQuery from '../../procedures/http-build-query';
import FiltersType from './listingFiltersTypesConstants';

export default {
  path: '/banking-operations/settle/:id',
  filters: [
    {
      key: 'fulltext',
      placeholder: 'Wpisz frazę do znalezienia',
      shortPlaceholder: 'Szukaj',
      badge: 'Szukana fraza:',
      testName: 'banking-operations-filter-fulltext',
      inputType: FiltersType.TEXT_SEARCH_TYPE,
      reset: async () => ({ value: '' }),
    },
    {
      key: '_evidence_clients_multi',
      getItems: async () => {
        let { data } = await CrmApi.index(HttpBuildQuery({ list: true }));
        delete data.pagination;

        return Object.values(data)
          .map((item) => {
            return {
              value: item.client.person.company.original,
              label: `${ crmName(item) }`,
            };
          });
      },
      reset: async () => null,
      placeholder: 'Kontrahent',
      badge: 'Kontrahent:',
      testName: 'test_filter_evidence_client',
      inputType: FiltersType.MULTI_SELECT_TYPE,
    },
    {
      key: '_settlement_status_multi',
      getItems: async () => [
        {
          value: BANKING.SETTLEMENT_STATUSES.PENDING.value,
          label: BANKING.SETTLEMENT_STATUSES.PENDING.label,
        },
        {
          value: BANKING.SETTLEMENT_STATUSES.PARTIALLY_SETTLED.value,
          label: BANKING.SETTLEMENT_STATUSES.PARTIALLY_SETTLED.label,
        },
      ],
      reset: async () => null,
      placeholder: 'Status',
      badge: 'Status:',
      testName: 'test_filter_settlement_status',
      inputType: FiltersType.MULTI_SELECT_TYPE,
    },
    {
      key: 'operation_date',
      reset: async () => ({ value: { fromVal: null, toVal: null } }),
      placeholder: '',
      badge: 'Zakres dat operacji',
      testName: 'banking-operations-filter-date-range',
      inputType: FiltersType.RANGE_TYPE,
      htmlInputType: 'date',
    },
    {
      key: 'amount',
      reset: async () => ({ value: '' }),
      placeholder: 'Kwota',
      badge: 'Kwota',
      testName: 'banking-operations-filter-amount',
      inputType: FiltersType.TEXT_SEARCH_TYPE,
      htmlInputType: 'text',
    },
    {
      key: 'evidencekind.id',
      getItems: async () => [
        { value: EvidenceKind.INCOME, label: 'Przychód' },
        { value: EvidenceKind.COST, label: 'Koszt' },
      ],
      reset: async () => null,
      placeholder: 'Rodzaj',
      badge: 'Rodzaj:',
      testName: 'test_filter_evidence_kind',
      inputType: FiltersType.SELECT_TYPE,
      disabled: true,
    },
  ],
};
